import { useEffect } from "react";
import { imageUploadSlice } from "../store/slices/ImageUploads";
import { useDispatch } from "react-redux";

export const useDeviceFeatures = () => {
  const dispatch = useDispatch();

  const deviceHasCamera = async () => {
    let hasCamera = false;
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      hasCamera = devices.some((d) => d.kind === "videoinput");
    } catch {
      hasCamera = false;
    }
    return hasCamera;
  };

  async function isMobileOrTablet() {
    const hasCamera = await deviceHasCamera();
    const coarsePointer = matchMedia("(pointer: coarse)").matches;
    const smallScreen = window.innerWidth <= 1024;
    const touch = navigator.maxTouchPoints > 0;

    return (
      (touch && coarsePointer) ||
      (smallScreen && coarsePointer) ||
      (hasCamera && coarsePointer)
    );
  }

  useEffect(() => {
    const checkDevice = async () => {
      const isMobileTablet = await isMobileOrTablet();
      dispatch(
        imageUploadSlice.actions.setMobileDeviceWithCamera(isMobileTablet)
      );
    };
    checkDevice();
  }, []);
};
